<div class="col-sm-12 ficheChantier" *ngIf="!isModif && !isCreate" style="height: 100%; padding-top: 5px;">
  <div class="fiche">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-6 fiche-client">
        <div *ngIf="!add" class="numchantier"> {{ chantier.numChantier }} </div>
        <div *ngIf="add"> Création Chantier </div>
        <span class="col-sm-12 ville" *ngIf="!add"> {{ chantier.ville }} </span>
      </div>
      <button class="uppercase" *ngIf="edit && !add" (click)="updateChantier(this.chantier)"> Enregistrer </button>
      <button class="uppercase" *ngIf="add" (click)="createChantier()"> Valider </button>
      <button class="uppercase" *ngIf="!edit && !disablemodif" (click)="editChantier()">Modifier </button>
      <button class="uppercase btn-close" (click)="showFiche()"> Fermer </button>
    </div>

    <div class="col-sm-12" style="padding-right: 0;" [ngStyle]="{'padding-top': add ? '5px' : '0px'}">
      <div class="input-group col-sm-12 recherche">
        <input  type="text" id="ficheinput2" class="form-control"
          placeholder="Rechercher une donnée chantier" [(ngModel)]="searchCritere" (keyup.enter)="filtreSearch($event)"
          (ngModelChange)="changeRecherche()" />
        <div class="input-group-addon">
          <img src="assets/images/icons/search.svg" class="pull-right" alt="search" />
        </div>
      </div>
    </div>
  </div>
  <div class="contente" *ngIf="!isEmpty">
    <div class="info-client cht col-sm-12 pull-right">
      <ngb-tabset #t="ngbTabset" *ngIf="!isRecherche">
        <ngb-tab title="Général" *ngIf="isGeneral">
          <ng-template ngbTabContent>
            <div class="col-sm-12">
              <div *ngIf="add" style="font-size: 10px;"> (
                <span style="color:red;">*</span>) : Champs obligatoires </div>
              <app-info-general [chantier]="chantier" [isTypeDetenteur] = 'isTypeDetenteur'  [edit]="edit" [add]="add" [hidetitle]="true" [client]="client"
                (clickadresse)="copieAdresse()"></app-info-general>
            </div>
          </ng-template>
        </ngb-tab>
        <ngb-tab id="tab-selectbyid2" *ngIf="isSupp">
          <ng-template ngbTabTitle> Infos Supp </ng-template>
          <ng-template ngbTabContent>
            <div class="col-sm-12">
              <app-info-supp  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [listeterritoire]="listeterritoire" [hidetitle]="true"
                [listeagence]="listeagence" (createfct)="createAgence()" (editfct)="editAgence()"></app-info-supp>
            </div>
          </ng-template>
        </ngb-tab>
        <ngb-tab title="Infos Fact." *ngIf="isFact">
          <ng-template ngbTabContent>
            <div class="col-sm-12">
              <app-info-fact  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true"></app-info-fact>
            </div>
          </ng-template>
        </ngb-tab>
        <ngb-tab title="Documents" *ngIf="isDoc">
          <ng-template ngbTabContent>
            <div class="col-sm-12"  style="height: 100%" >
              <app-doc  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true"></app-doc>
            </div>
          </ng-template>
        </ngb-tab>
        <ngb-tab title="Amiante" *ngIf="isAmiante">
          <ng-template ngbTabContent>
            <div class="col-sm-12">
              <app-amiante  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true"></app-amiante>
            </div>
          </ng-template>
        </ngb-tab>
        <ngb-tab title="Détenteur" *ngIf="isDetenteur && !hideDetenteur">
          <ng-template ngbTabContent>
            <div class="col-sm-12">
              <app-info-detenteur  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true" [listeagence]="listeagence">
              </app-info-detenteur>
            </div>
          </ng-template>
        </ngb-tab>
      </ngb-tabset>
      <div class="col-sm-12"  *ngIf="isRecherche"
        style="background-color: #dbe8f8; padding: 5px 20px; letter-spacing: 2px;"> Résultat de la recherche </div>
      <div class="col-sm-12 searchblock" [ngStyle]="{'display': isRecherche ? 'block': 'none'}">
        <div *ngIf="add" style="font-size: 10px;"> (
          <span style="color:red;">*</span>) : Champs obligatoires </div>
        <app-info-general [chantier]="chantier" [isTypeDetenteur] = 'isTypeDetenteur'  [edit]="edit" [add]="add" [hidetitle]="true" [client]="client"
          (clickadresse)="copieAdresse()" *ngIf="isGeneral"></app-info-general>
        <app-info-supp  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [listeterritoire]="listeterritoire" [hidetitle]="true"
          [listeagence]="listeagence" (createfct)="createAgence()" (editfct)="editAgence()" *ngIf="isSupp">
        </app-info-supp>
        <app-info-fact  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true" *ngIf="isFact"></app-info-fact>
        <app-doc  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true" *ngIf="isDoc"></app-doc>
        <app-amiante  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true" *ngIf="isAmiante"></app-amiante>
        <app-info-detenteur  [ngClass]="{'disabledbutton': client && client.prospectHolding }" [chantier]="chantier" [edit]="edit" [hidetitle]="true" [listeagence]="listeagence"
          *ngIf="isDetenteur && !hideDetenteur  "></app-info-detenteur>
      </div>

    </div>
  </div>
</div>

<div *ngIf="isModif || isCreate" class="col-sm-12 ficheChantier" style="height: 100%;">
  <div class="col-sm-12" *ngIf="isModif" style="height: 100%;">
    <app-fiche-agence [chantier]="chantier" [agence]="chantier.agence" [client]="chantier.client"
      (hidefunction)="editAgence();" (aftersave)="getValue($event);" [edit]="true"></app-fiche-agence>
  </div>
  <div class="col-sm-12" *ngIf="isCreate" style="height: 100%;">
    <app-fiche-agence [chantier]="chantier" [client]="chantier.client" [add]="true" (hidefunction)="createAgence();"
      (aftersave)="getValue($event);" [edit]="true"></app-fiche-agence>
  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <label class="cofirmemsg" style="font-family: Roboto-Black; font-size: 15px;"> {{ error }} </label>
          </div>
      </div>
      <div class="text-right" style="margin-top: 15px;">
          <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
      </div>
  </div>
</ng-template>

<ng-template #loadingSygetrack>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ nomInformatiqueImbrique }} </h4>
  </div>     
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <label class="cofirmemsg" style="font-family: Roboto-Black; font-size: 15px; text-align: justify" 
                  [innerHTML]="msgSygetrack ? msgSygetrack : 'Attente du retour de ' + nomInformatiqueImbrique"></label>
          </div>
      </div>
      
      <div class="text-right" style="margin-top: 15px;" *ngIf="msgSygetrack">
          <button type="button" class=" btn-close btn-valider" (click)="closeSygetrack()"> Fermer </button>
      </div>
  </div>
</ng-template>


<ng-template #choixTypeHabitat>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Choix type d'habitat </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12 mb-3">
        <label class="cofirmemsgChant"> Veuillez renseigner le type d'habitat </label>
      </div>
      <div class="col-sm-12">
        <div class="col-sm-4">
          <label class="cofirmemsg"> Type d'habitat : </label>
        </div>
        <div class="col-sm-8">
          <app-autocomplete [disablefocus]="true" (selectfunction)="chantier.typeHabitat = $event"
            [results]="resultTypeHabitat" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
            [defaultselected]="chantier.typeHabitat"
            [defaultsearch]="chantier.typeHabitat ? (chantier.typeHabitat.libelle || chantier.typeHabitat.libelleObjetEntite ||'') : ''">
          </app-autocomplete>
        </div>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class="btn-close btn-valider" (click)="common.closeModal();updateChantier(chantier);">
        VALIDER
      </button>
      <!-- <button type="button" class="btn-close btn-non" (click)="common.closeModal();"> NON</button> -->
    </div>
  </div>
</ng-template>
